module.exports = __webpack_public_path__ + "static/img/icon_yiyuan.f10fc784.png";